import React, { useState } from 'react';
import { CalendarIcon, PlusIcon, XIcon, ClockIcon, LockIcon } from 'lucide-react';
interface DoctorCalendarProps {
  doctorId: number;
}
const mockBlockedSlots = [{
  id: 1,
  date: '2024-01-20',
  startTime: '10:00',
  endTime: '11:00',
  reason: 'Surgery',
  type: 'surgery'
}, {
  id: 2,
  date: '2024-01-22',
  startTime: '14:00',
  endTime: '15:00',
  reason: 'Admin Meeting',
  type: 'meeting'
}, {
  id: 3,
  date: '2024-01-25',
  startTime: '09:00',
  endTime: '12:00',
  reason: 'Medical Conference',
  type: 'admin'
}];
export function DoctorCalendar({
  doctorId
}: DoctorCalendarProps) {
  const [showBlockForm, setShowBlockForm] = useState(false);
  const [blockFormData, setBlockFormData] = useState({
    date: '',
    startTime: '',
    endTime: '',
    reason: '',
    type: 'admin'
  });
  const handleBlockSlot = () => {
    alert(`Calendar blocked from ${blockFormData.startTime} to ${blockFormData.endTime} on ${blockFormData.date}`);
    setShowBlockForm(false);
    setBlockFormData({
      date: '',
      startTime: '',
      endTime: '',
      reason: '',
      type: 'admin'
    });
  };
  const getTypeColor = (type: string) => {
    switch (type) {
      case 'surgery':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'meeting':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'admin':
        return 'bg-purple-100 text-purple-800 border-purple-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };
  return <div className="space-y-6" data-id="element-329">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-330">
        <div data-id="element-331">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-332">
            Calendar Management
          </h2>
          <p className="text-sm text-gray-600 mt-1" data-id="element-333">
            Block time slots for surgeries, meetings, and admin tasks
          </p>
        </div>
        <button onClick={() => setShowBlockForm(true)} className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700" data-id="element-334">
          <LockIcon className="w-4 h-4" data-id="element-335" />
          <span data-id="element-336">Block Time Slot</span>
        </button>
      </div>
      {/* Calendar Sync Options */}
      <div className="border border-gray-200 rounded-lg p-6" data-id="element-337">
        <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-338">
          Calendar Sync (Optional)
        </h3>
        <div className="space-y-3" data-id="element-339">
          <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg" data-id="element-340">
            <div className="flex items-center space-x-3" data-id="element-341">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-342">
                <CalendarIcon className="w-5 h-5 text-blue-600" data-id="element-343" />
              </div>
              <div data-id="element-344">
                <h4 className="font-medium text-gray-900" data-id="element-345">Google Calendar</h4>
                <p className="text-sm text-gray-600" data-id="element-346">
                  Bi-directional sync with Google Calendar
                </p>
              </div>
            </div>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm" data-id="element-347">
              Connect
            </button>
          </div>
          <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg" data-id="element-348">
            <div className="flex items-center space-x-3" data-id="element-349">
              <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center" data-id="element-350">
                <CalendarIcon className="w-5 h-5 text-indigo-600" data-id="element-351" />
              </div>
              <div data-id="element-352">
                <h4 className="font-medium text-gray-900" data-id="element-353">Outlook Calendar</h4>
                <p className="text-sm text-gray-600" data-id="element-354">
                  Bi-directional sync with Microsoft Outlook
                </p>
              </div>
            </div>
            <button className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-sm" data-id="element-355">
              Connect
            </button>
          </div>
        </div>
        <p className="text-sm text-gray-500 mt-4" data-id="element-356">
          Note: When connected, blocked time slots will automatically sync with
          your external calendar
        </p>
      </div>
      {/* Block Time Slot Form */}
      {showBlockForm && <div className="border border-purple-200 bg-purple-50 rounded-lg p-6" data-id="element-357">
          <div className="flex items-center justify-between mb-4" data-id="element-358">
            <h3 className="text-lg font-semibold text-gray-900" data-id="element-359">
              Block Time Slot
            </h3>
            <button onClick={() => setShowBlockForm(false)} className="text-gray-500 hover:text-gray-700" data-id="element-360">
              <XIcon className="w-5 h-5" data-id="element-361" />
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-362">
            <div data-id="element-363">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-364">
                Date
              </label>
              <input type="date" value={blockFormData.date} onChange={e => setBlockFormData({
            ...blockFormData,
            date: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" data-id="element-365" />
            </div>
            <div data-id="element-366">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-367">
                Block Type
              </label>
              <select value={blockFormData.type} onChange={e => setBlockFormData({
            ...blockFormData,
            type: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" data-id="element-368">
                <option value="admin" data-id="element-369">Admin Task</option>
                <option value="meeting" data-id="element-370">Meeting</option>
                <option value="surgery" data-id="element-371">Surgery</option>
              </select>
            </div>
            <div data-id="element-372">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-373">
                Start Time
              </label>
              <input type="time" value={blockFormData.startTime} onChange={e => setBlockFormData({
            ...blockFormData,
            startTime: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" data-id="element-374" />
            </div>
            <div data-id="element-375">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-376">
                End Time
              </label>
              <input type="time" value={blockFormData.endTime} onChange={e => setBlockFormData({
            ...blockFormData,
            endTime: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" data-id="element-377" />
            </div>
            <div className="md:col-span-2" data-id="element-378">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-379">
                Reason
              </label>
              <input type="text" value={blockFormData.reason} onChange={e => setBlockFormData({
            ...blockFormData,
            reason: e.target.value
          })} placeholder="e.g., Heart Surgery, Team Meeting, Conference" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" data-id="element-380" />
            </div>
          </div>
          <div className="flex justify-end space-x-3 mt-4" data-id="element-381">
            <button onClick={() => setShowBlockForm(false)} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50" data-id="element-382">
              Cancel
            </button>
            <button onClick={handleBlockSlot} className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700" data-id="element-383">
              Block Time Slot
            </button>
          </div>
        </div>}
      {/* Blocked Time Slots */}
      <div className="border border-gray-200 rounded-lg p-6" data-id="element-384">
        <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-385">
          Blocked Time Slots
        </h3>
        {mockBlockedSlots.length === 0 ? <p className="text-gray-500 text-center py-8" data-id="element-386">
            No blocked time slots
          </p> : <div className="space-y-3" data-id="element-387">
            {mockBlockedSlots.map(slot => <div key={slot.id} className={`p-4 border-2 rounded-lg ${getTypeColor(slot.type)}`} data-id="element-388">
                <div className="flex items-start justify-between" data-id="element-389">
                  <div className="flex-1" data-id="element-390">
                    <div className="flex items-center space-x-3 mb-2" data-id="element-391">
                      <LockIcon className="w-5 h-5" data-id="element-392" />
                      <h4 className="font-semibold" data-id="element-393">{slot.reason}</h4>
                      <span className="px-2 py-1 bg-white bg-opacity-50 rounded text-xs font-medium" data-id="element-394">
                        {slot.type.charAt(0).toUpperCase() + slot.type.slice(1)}
                      </span>
                    </div>
                    <div className="flex items-center space-x-4 text-sm" data-id="element-395">
                      <div className="flex items-center space-x-1" data-id="element-396">
                        <CalendarIcon className="w-4 h-4" data-id="element-397" />
                        <span data-id="element-398">{slot.date}</span>
                      </div>
                      <div className="flex items-center space-x-1" data-id="element-399">
                        <ClockIcon className="w-4 h-4" data-id="element-400" />
                        <span data-id="element-401">
                          {slot.startTime} - {slot.endTime}
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="text-red-600 hover:text-red-700 text-sm font-medium" data-id="element-402">
                    Remove
                  </button>
                </div>
              </div>)}
          </div>}
      </div>
    </div>;
}